"use client";

export default function ErrorPage({ reset }: { reset: () => void }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <p className="text-lg">Bir sorun oluştu, lütfen tekrar deneyin.</p>
      <button
        className="rounded-md bg-primary px-4 py-2 text-sm text-white"
        onClick={reset}
        type="button"
      >
        Tekrar Dene
      </button>
    </div>
  );
}
